export default __webpack_public_path__ + "static/roslinki2-8f206d9102b02325d6883f7d7652966d.png";